<template>
  <div>
    <drag-dialog
      title="创建项目"
      :visible.sync="visible"
      :footerBtn="['cancel', 'submit']"
      :defaultTop="200"
      :defaultLeft="680"
      :submit="submit"
      :cancel="cancel">
      <el-form
        class="form public-form-primary"
        :model="form"
        :rules="rules"
        label-width="84px"
        ref="form">
        <el-form-item
          label="项目名称:"
          prop="projName">
          <el-input
            :maxlength="30"
            show-word-limit
            v-model="form.projName"
            placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item
          v-if="isBindProj"
          label="项目关联:">
          <div class="common-select-box">
            <el-select
              size="small"
              remote
              filterable
              v-model="bindProjId"
              clearable
              :remote-method="filterCustomerProj"
              :popper-append-to-body="false"
              placeholder="请选择需要关联的项目"
              @clear="handleClearFilter">
              <div v-infinite-scroll="handleScroll">
                <el-option
                  v-for="(item, index) in customerProjList"
                  :key="index"
                  :label="item.SectionName"
                  :value="item.SectionGUID">
                  <div
                    class="text-overflow"
                    :title="item.SectionName">
                    {{ item.SectionName }}
                  </div>
                </el-option>
              </div>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item
          label="项目地点:"
          v-if="!baiduDisabled">
          <el-input
            readonly
            placeholder="请选择项目地点"
            v-model="form.location.streetName"
            ><i
              slot="suffix"
              class="el-icon-location-outline icon"
              @click="addLocation"></i>
          </el-input>
        </el-form-item>
        <el-form-item
          label="项目概述:"
          prop="overview">
          <el-input
            v-model="form.overview"
            autocomplete="off"
            placeholder="请输入项目概况"
            type="textarea"
            maxlength="200"
            rows="5"
            show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="缩略图:">
          <div class="avatar-uploader">
            <el-upload
              class="upload-primary"
              ref="upload"
              :action="action"
              :headers="headers"
              :data="uploadParams"
              name="FileInfo"
              accept=".jpg,.jpeg,.png,.gif,.tif,.psd"
              :show-file-list="false"
              :on-change="handleChange"
              :on-success="handleAvatarSuccess"
              :on-error="onAvatarError"
              :auto-upload="false">
              <img
                v-if="form.thumbnail"
                :src="`${imageBaseUrl}/${form.thumbnail}`"
                :class="form.thumbnail ? 'avatar not-avatar' : 'avatar'" />
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="img-description public-tips-primary">
              支持jpg、jpeg、png、gif、bmp、tif格式，推荐尺寸为350×220
            </div>
          </div>
        </el-form-item>
      </el-form>
    </drag-dialog>
    <div v-show="locationDialogVisible">
      <drag-dialog
        title="选择项目地点"
        :width="800"
        :visible.sync="mapVisible"
        :footerBtn="['cancel', 'submit']"
        :defaultTop="155"
        :defaultLeft="530"
        :submit="submitLocation"
        :cancel="cancelLocation">
        <div class="map-box">
          <div
            id="bmap"
            class="map-container"></div>
          <div class="search-box">
            <el-input
              id="suggestId"
              v-model="keywords"
              placeholder="请输入地点名称"></el-input>
          </div>
        </div>
      </drag-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import dragDialog from './DragDialog.vue'

import { addSingleProject } from '@/service/interface'
import {
  getBase64,
  compressImgBySize,
  getToken,
  getTokenId
} from '@/utils/generalMethods'

let BMapGL = null
const municipality = ['北京市', '天津市', '上海市', '重庆市']
const CompressSize = 2 * 1024 * 1024

export default {
  data() {
    const validDisplayNameRule = (rule, value, callback) => {
      if (value.length === value.trimStart().trimEnd().length) {
        return callback()
      } else {
        callback(new Error('开头和结尾不允许有空格'))
      }
    }

    return {
      imageBaseUrl: window.imageBaseUrl,
      baiduDisabled: window.baiduDisabled,
      locationDialogVisible: false,
      mapVisible: true,
      keywords: '',
      projectList: [],
      singleList: [],
      headers: {
        Authorization: this.getToken()
      },
      uploadParams: {
        FileSize: '',
        FileName: ''
      },
      form: {
        projName: '',
        location: {
          cityName: '',
          streetName: '',
          coord: ''
        },
        overview: '',
        thumbnail: ''
      },
      // 绑定第三方客户项目相关
      isBindProj: window.isBindProj,
      customerToken: '',
      bindProjId: '',
      customerProjList: [],
      currPage: 1,
      pageSize: 20,
      isAllProjLoaded: false,

      rules: {
        projName: [
          {
            required: true,
            message: '请输入项目名称',
            trigger: 'blur'
          },
          // {
          //   pattern:
          //     /^[\u4e00-\u9fa5_a-zA-Z0-9_\@_\#_\&_\*_\%_\(_\)_\（_\）_\/_\._\-_\\__\[_\]_\s_]*$/g,
          //   message: "只允许汉字,数字,字母,空格和@ # & * %（）/ . - _",
          //   trigger: "change",
          // },
          { validator: validDisplayNameRule }
        ]
      }
    }
  },
  props: {
    visible: Boolean,
    closeDialog: Function,
    refreshProjList: Function
  },
  components: {
    dragDialog
  },
  created() {
    this.action = `${window.serverUrl}/${this.$logServeCof()}/project/fileManage/v3/projectImage/upload`
    BMapGL = window.BMapGL

    if (window.isBindProj) {
      this.initCustomerProjList()
    }
  },
  watch: {
    locationDialogVisible: function (newValue) {
      if (newValue) {
        if (!this.map) {
          this.initMap()
        }
      }
    }
  },
  methods: {
    submit() {
      if (window.isBindProj && !this.bindProjId) {
        this.$message.warning('请选择需要关联的项目')
        return
      }

      this.$refs.form.validate((bool, object) => {
        if (bool) {
          if (window.isStarRiver) {
            addSingleProject(this.form).then(response => {
              if (response.isSuccess) {
                let data = response.data
                let blackholeProjId = data.projId
                this.bindThirdPartyProj(blackholeProjId).then(() => {
                  this.refreshProjList().then(() => {
                    this.$message.success('新建成功!')
                    this.clearForm()
                    this.closeDialog()
                  })
                })
              } else {
                this.$message.error(response.errMsg)
                this.clearForm()
              }
            })
          } else {
            this.$confirm(
              '请检查确认项目名称，一经保存，再次修改需要提交审核，是否保存?',
              '保存项目提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }
            )
              .then(() => {
                addSingleProject(this.form).then(response => {
                  if (response.isSuccess) {
                    let data = response.data
                    let blackholeProjId = data.projId
                    this.bindThirdPartyProj(blackholeProjId).then(() => {
                      this.refreshProjList().then(() => {
                        this.$message.success('新建成功!')
                        this.clearForm()
                        this.closeDialog()
                      })
                    })
                  } else {
                    this.$message.error(response.errMsg)
                    this.clearForm()
                  }
                })
              })
              .catch(() => {
                this.$message.info('取消保存!')
              })
          }
        } else {
          this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
        }
      })
    },
    // 绑定第三方项目
    bindThirdPartyProj(blackholeProjId) {
      return new Promise(resolve => {
        if (!window.isBindProj) {
          resolve()
          return
        }

        this.getCustomerToken().then(access_token => {
          let headers = {
            Authorization: `Bearer ${access_token}`
          }
          let params = {
            sectionGUID: this.bindProjId,
            bimProjectId: blackholeProjId
          }
          let serverUrl = `${window.customerServerUrl}/Project/RelationSectionData`
          axios.post(serverUrl, params, { headers }).then(result => {
            if (result.status === 200) {
              let response = result.data
              if (response.success) {
                resolve()
              } else {
                this.$message.error(response.errorMessage)
              }
            } else {
              this.customerToken = ''
              this.$message.error('获取第三方请求失败')
            }
          })
        })
      })
    },
    cancel() {
      this.clearForm()
      this.closeDialog()
    },
    addLocation() {
      this.locationDialogVisible = true

      if (this.form.location.streetName) {
        this.$nextTick(() => {
          this.autoComplete.setInputValue(this.form.location.streetName)
          // 清除地图上所有的覆盖物;
          this.map.clearOverlays()
          let latLng = this.form.location.coord.split(',')
          let point = new BMapGL.Point(Number(latLng[1]), Number(latLng[0]))
          let marker = new BMapGL.Marker(point)
          this.map.addOverlay(marker)
          this.map.setCenter(point)
        })
      }
    },
    submitLocation() {
      if (!this.addressInfo) {
        this.$message.warning('请选择项目地点')
        return
      }
      this.form.location = this.addressInfo
      this.clearMap()

      this.locationDialogVisible = false
    },
    cancelLocation() {
      this.clearMap()
      this.locationDialogVisible = false
    },
    clearForm() {
      this.form = {
        projName: '',
        location: {
          cityName: '',
          streetName: '',
          coord: ''
        },
        overview: '',
        thumbnail: ''
      }
    },
    initMap() {
      this.map = new BMapGL.Map('bmap')
      let point = new BMapGL.Point(116.404, 39.915)
      this.map.centerAndZoom(point, 15)
      this.map.enableScrollWheelZoom()
      this.geoCoder = new BMapGL.Geocoder()

      this.map.addEventListener('click', this.mapClick)

      this.autoComplete = new BMapGL.Autocomplete({
        input: 'suggestId',
        location: this.map
      })
      this.autoComplete.addEventListener('onconfirm', this.locationClick)
    },
    mapClick(e) {
      //清除地图上所有的覆盖物
      this.map.clearOverlays()
      let point = e.latlng
      let marker = new BMapGL.Marker(new BMapGL.Point(point.lng, point.lat))
      this.map.addOverlay(marker)

      this.geoCoder.getLocation(point, result => {
        let addressInfo = result.addressComponents

        let cityName = ''
        if (municipality.includes(addressInfo.province)) {
          cityName = `${addressInfo.city}·${addressInfo.district}`
        } else {
          cityName = `${addressInfo.province}·${addressInfo.city}`
        }
        let streetName = `${addressInfo.city}${addressInfo.district}${addressInfo.street}`
        let coord = `${point.lat.toFixed(6)},${point.lng.toFixed(6)}`

        this.keywords = streetName

        this.addressInfo = {
          cityName,
          streetName,
          coord
        }
      })
    },
    locationClick(e) {
      //鼠标点击下拉列表后的事件
      let value = e.item.value
      this.keywords = value.business

      this.locationToAddress(value)
    },
    locationToAddress(value) {
      this.map.clearOverlays()

      let local = new BMapGL.LocalSearch(this.map, {
        //智能搜索
        onSearchComplete: () => {
          let point = local.getResults().getPoi(0).point //获取第一个智能搜索的结果
          this.map.centerAndZoom(point, 18)
          this.map.addOverlay(new BMapGL.Marker(point)) //添加标注

          let addressInfo = local.getResults()

          let cityName = ''
          if (municipality.includes(addressInfo.province)) {
            cityName = `${value.city}·${value.district}`
          } else {
            if (addressInfo.province === value.city) {
              cityName = `${addressInfo.province}·${value.district}`
            } else {
              cityName = `${addressInfo.province}·${value.city}`
            }
          }
          let streetName = value.business
          let coord = `${point.lat.toFixed(6)},${point.lng.toFixed(6)}`

          this.addressInfo = {
            cityName,
            streetName,
            coord
          }
        }
      })

      let address = `${value.province}${value.city}${value.district}${value.street}${value.business}`
      local.search(address)
    },
    handleChange(file) {
      this.$set(this.uploadParams, 'FileName', file.name)

      if (file.size < CompressSize) {
        this.$set(this.uploadParams, 'FileSize', file.size)
        this.$refs.upload.submit()
      } else {
        this.getBase64(file.raw).then(response => {
          this.compressImgBySize(response, 2 * 1024).then(res => {
            let fileOfBlob = new File([res], file.name)
            this.$set(this.uploadParams, 'FileSize', fileOfBlob.size)
            this.$set(this.uploadParams, 'FileInfo', fileOfBlob)
            this.$refs.upload.submit()
          })
        })
      }
    },
    handleAvatarSuccess(response, file) {
      // 图片上传成功
      if (response.isSuccess) {
        let data = response.data
        this.form.thumbnail = data.savePath
      } else {
        this.$message.error(response.errMsg)
      }
    },
    onAvatarError() {
      this.$message.error('图片上传失败')
    },
    clearMap() {
      this.map.clearOverlays()
      this.autoComplete.setInputValue('')
      this.keywords = ''
      let point = new BMapGL.Point(116.404, 39.915)
      this.map.centerAndZoom(point, 15)
    },
    handleClearFilter() {
      this.currPage = 1
      this.isAllProjLoaded = false
      this.customerProjName = ''

      this.queryCustomerProjList().then(projList => {
        this.customerProjList = projList
      })
    },
    filterCustomerProj(customerProjName) {
      this.currPage = 1
      this.isAllProjLoaded = false
      this.customerProjName = customerProjName

      this.queryCustomerProjList().then(projList => {
        this.customerProjList = projList
      })
    },
    handleScroll() {
      if (this.isAllProjLoaded || this.customerProjName) return
      this.currPage++

      this.queryCustomerProjList().then(projList => {
        if (projList.length) {
          this.customerProjList = [...this.customerProjList, ...projList]
        } else {
          this.isAllProjLoaded = true
        }
      })
    },
    initCustomerProjList() {
      this.currPage = 1
      this.queryCustomerProjList().then(projList => {
        this.customerProjList = projList
      })
    },
    // 获取客户token
    getCustomerToken() {
      return new Promise(resolve => {
        if (this.customerToken) {
          resolve(this.customerToken)
        } else {
          let params = {
            client_id: window.customerClientId,
            client_secret: window.customerSecretKey
          }
          let serverUrl = `${window.customerServerUrl}/MIPApiAuth/Token`
          axios.post(serverUrl, params).then(result => {
            if (result.status === 200) {
              let response = result.data
              let access_token = response.access_token
              resolve(access_token)
            } else {
              this.$message.error('获取第三方请求失败')
            }
          })
        }
      })
    },
    queryCustomerProjList() {
      return new Promise(resolve => {
        this.getCustomerToken().then(access_token => {
          let headers = {
            Authorization: `Bearer ${access_token}`
          }
          let params = {
            sectionName: this.customerProjName,
            page: this.currPage - 1,
            page_size: this.pageSize
          }
          let serverUrl = `${window.customerServerUrl}/Project/GetSectionData`
          axios.post(serverUrl, params, { headers }).then(result => {
            if (result.status === 200) {
              let response = result.data
              let projList = response.Data
              resolve(projList)
            } else {
              this.customerToken = ''
              this.$message.error('获取第三方请求失败')
            }
          })
        })
      })
    },
    getBase64,
    compressImgBySize,
    getToken,
    getTokenId
  }
}
</script>

<style lang="less" scoped>
.form {
  padding-right: 5px;
  .el-form-item {
    .el-select {
      width: 100%;
    }

    .icon {
      font-size: 25px;
      line-height: 40px;
      cursor: pointer;
    }
  }

  //图片上传的样式
  .avatar-uploader {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    /deep/ .el-upload {
      width: 120px;
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px;
      &:has(.not-avatar):hover {
        background: none;
      }

      .el-icon-plus {
        font-size: 26px;
      }

      .avatar {
        width: 100%;
        height: 100%;
        object-fit: fill;
      }
    }

    .img-description {
      color: var(--base-light-color2);
    }
  }
}
.map-box {
  height: 600px;

  .map-container {
    height: 100%;
  }

  .search-box {
    position: absolute;
    top: 65px;
    left: 20px;
    width: 300px;
    z-index: 9;
  }
}
.tangram-suggestion-main {
  z-index: 9;
}
</style>
